import api, { ApiResponse, PageResponse } from './api'
import type {
  MerchantSubscriptionCancelResponse,
  MerchantSubscriptionDetail,
  MerchantSubscriptionInvoiceSummary,
  MerchantSubscriptionListItem,
  SubscriptionStatus
} from '../types'

export interface SubscriptionListParams {
  page?: number
  size?: number
  subscriptionId?: string
  status?: SubscriptionStatus
  planId?: string
  customerEmail?: string
  createdStartAt?: number
  createdEndAt?: number
  nextBillingStartAt?: number
  nextBillingEndAt?: number
}

export interface CancelSubscriptionRequest {
  cancelAtPeriodEnd: boolean
  reason?: string
  requestKey?: string
}

export function getSubscriptions(
  params: SubscriptionListParams
): Promise<ApiResponse<PageResponse<MerchantSubscriptionListItem>>> {
  return api.get('/v1/merchant/subscriptions', { params })
}

export function getSubscription(id: string): Promise<ApiResponse<MerchantSubscriptionDetail>> {
  return api.get(`/v1/merchant/subscriptions/${id}`)
}

export function getSubscriptionInvoices(
  id: string,
  params: { page?: number; size?: number }
): Promise<ApiResponse<PageResponse<MerchantSubscriptionInvoiceSummary>>> {
  return api.get(`/v1/merchant/subscriptions/${id}/invoices`, { params })
}

export function cancelSubscription(
  id: string,
  data: CancelSubscriptionRequest
): Promise<ApiResponse<MerchantSubscriptionCancelResponse>> {
  return api.post(`/v1/merchant/subscriptions/${id}/cancel`, data)
}
